import React, { useState, useEffect } from "react";
import send from "../../src/assets/images/send1.png";
import click from "../../src/assets/images/check1.png";
import down from "../../src/assets/images/download.png";
import star from "../../src/assets/images/stars.png";
import { toastMsg } from "../component/toast";
import { useSelector, useDispatch } from "react-redux";
import FileSaver from "file-saver";
import download from '../assets/images/download.svg'
import {
  PostCallWithErrorResponse, simpleDeleteCall,
  simpleGetCallWithErrorResponse,
} from "../Api/ApiServices";
import { Link, useNavigate } from "react-router-dom";
import war from "../../src/assets/images/war.png";
import like from "../../src/assets/images/likes.png";
import pen from "../../src/assets/images/pen1.png";
import del from "../../src/assets/images/del1.png";
import Spinner from "react-bootstrap/Spinner";
import check from "../assets/images/checkkk.svg";
import { Form, FormGroup, FormLabel, FormControl, Row, Col, Modal } from "react-bootstrap"

import close from "../assets/images/x-close.svg";
import { ShimmerText, ShimmerTable, ShimmerSimpleGallery } from "react-shimmer-effects";
import {
  updateFormField,
  setFormData,
  resetFormData,
  setStep,
  setHeaderText,
  setSelectedKeywords,

} from "./Slices/formSlice";
import { simpleGetCall } from "../Api/ApiServices";
import { ApiConfig } from "../Api/ApiConfig";
import CustomButton from "../component/button";
import NewSkill from "../component/Skill/NewSkill";

export default function TotalMarketing({
  loadingForRegenerateSkills,
  regenerateSkillsAPI,
  loadingForGenerateJobDescription,
  generateJobDescriptionAPI,
  loadingForRegenerateJobDescription,
  generateJobResponsibilitiesAPI,
  loadingForRegenerateJobResponsibilities,
  componentRef,
  loadingForGettingBehaviour,
  loadingForGenerateKeyword,
  regenerateKeywordsForUserAPI,
  loadingForRegeneratedKeywords,
  loadingForRegeneratedJobDetails,
  regenerateJobDetailsAPI,
  loadingForGeneratedCustomQuestions,
  pubLishJDAPI,
  loadingForPublishJD,
  quizes,
  setQuizes,
  loadingForGenerateSkills

}) {
  const formData = useSelector((state) => state.form);
  const jdResponsesArrays = useSelector((state) => state.jdResponses);
  console.log("formData.behaviorsDataApi-->", formData.behaviorsDataApi);
  const [formDataQuiz, setFormDataQuiz] = useState({
    quizName: '',
    quizDuration: '',
  })
  const handleChangeForQuizDetails = (key, val) => {


    setFormDataQuiz(prev => ({
      ...prev,
      [key]: val
    }))

  }

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showDeleteQuizModal, setShowDeleteQuizModal] = useState(false);

  const handleCloseDeleteQuizModal = () => setShowDeleteQuizModal(false);
  const handleShowDeleteQuizModal = () => setShowDeleteQuizModal(true);

  const duration = [
    {
      label: '15 minutes',
      value: '15'
    },
    {
      label: '20 minutes',
      value: '20'
    },
    {
      label: '25 minutes',
      value: '25'
    },
    {
      label: '30 minutes',
      value: '30'
    },
    {
      label: '45 minutes',
      value: '45'
    },
    {
      label: '1 hours',
      value: '60'
    },
    {
      label: '15 minutes',
      value: '15'
    },

  ]
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSubmit, setIsSubmit] = useState(false)
  const handleSubmit = async () => {

    if (!formDataQuiz.quizDuration || !formDataQuiz.quizName) {
      toastMsg("error", "Please Enter Quiz Name And Quiz Duration");
      return;
    }

    setIsSubmit(true);

    PostCallWithErrorResponse(ApiConfig.POST_UPDATE_QUIZ, {
      quizId: quizId,
      name: formDataQuiz.quizName,
      duration: formDataQuiz.quizDuration

    }).then((res) => {
      if (res?.json?.succeded) {
        toastMsg("success", res?.json?.response?.statusMessage);

        // dispatch(updateFormField({ field: 'subTopics', value: [] }))
        // dispatch(updateFormField({ field: 'tTopics', value: [] }))
        // dispatch(updateFormField({ field: 'topics', value: [] }))
        // dispatch(updateFormField({ field: 'allSubTopics', value: [] }))
        // dispatch(updateFormField({
        //   field: 'customTopics', value: {
        //     topics: [],
        //     subTopics: [],
        //     previousSubTopics: []
        //   }
        // }))
        setFormDataQuiz({
          quizDuration: "",
          quizName: "",
        });
        getQuizes();

        //         if (state?.isAddQuizFromAddCode) {
        //           navigate(`/addEditGroup/${state?.tempJobCode}?detailsId=${state?.jdId}`)
        // 
        //           dispatch(updateFormField({ field: 'isAddQuizFromAddCode', value: false }))
        // 
        //           dispatch(updateFormField({ field: 'jdId', value: "" }))
        // 
        // 
        //           return
        //         }
        //         if (state?.isSkippedQuiz) {
        //           dispatch(updateFormField({ field: 'isSkippedQuiz', value: false }))
        //           navigate('/')
        //         } else {
        //           dispatch(
        //             updateFormField({
        //               field: "step",
        //               value: 3,
        //             })
        //           );
        //           navigate("/jobDescription")
        //         }

      } else {
        toastMsg("error", res?.json?.response?.statusMessage || 'Failed to update');
      }



    }).finally(() => {
      handleClose()
      setIsSubmit(false)
    })

  }
  const [isEditGroup, setIsEditGroup] = useState(false);
  const keywords = [
    "Digital Marketing",
    "Marketing Strategy",
    "Google Ads Management",
    "Meta Ads Management",
    "LinkedIn Ads Management",
  ];

  const [isAddCustInvt, setCustomInvt] = useState(false);
  const [showRegenerateBoxForBehaviour, setShowRegenerateBoxForBehaviour] =
    useState(false);
  const [showSuggestionOriginal, setShowSuggestionOriginal] = useState(false);
  const [
    showSuggestionOriginalForKeyword,
    setShowSuggestionOriginalForKeyword,
  ] = useState(false);
  const [
    showSuggestionOriginalForJobDetails,
    setShowSuggestionOriginalForJobDetails,
  ] = useState(false);
  const [showSuggestionOriginalForResp, setShowSuggestionOriginalForResp] =
    useState(false);
  const [isAddCustomDes, setIsAddCusDes] = useState(false);
  const [showRegenerateRespBox, setShowRegenerateRespBox] = useState(false);
  const [showKeywordRegenerateBox, setShowKeywordRegenerateBox] =
    useState(false);
  const [showJobDetailsRegenerateBox, setShowJobDetailsRegenerateBox] =
    useState(false);

  const [details, setDetails] = useState({
    customAddInvt: "",
    customGenInvt: "",
    customdDes: "",
    generetedDes: "",
  });

  const [displayAiGenerated, setISAiGenerated] = useState(true);
  const [colorOrgSuggForKeywords, setColorOrgSuggForKeywords] = useState(true);
  const [colorOrgSuggForJobDetails, setColorOrgSuggForJobDetails] =
    useState(true);

  const [displayAiGenrtdDes, setAiGenertdDes] = useState(true);
  const [dynamicJobRequirement, setDynamicJobRequirement] = useState([]);
  function transformJobDetailsToRequirementsDynamic(obj) {

    let skips = ['id', 'requiredBy', 'skillsets', 'role', 'step',]
    // delete obj.
    return Object.entries(obj).filter(([i]) => !skips?.includes(i)).map(([key, value]) => {

      let label = ''
      if (formData?.isView) {
        label = key.replace(/([A-Z])/g, ' $1').trim();
        label = label.charAt(0).toUpperCase() + label.slice(1);
      } else {
        label = key
          .replace(/_/g, " ") // replace underscores with spaces
          .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize first letter of each word

      }

      return {
        parameter: label,
        requirement: value,
      };
    });
  }

  useEffect(() => {
    if (formData.finalJobDetails) {
      const tempObj = transformJobDetailsToRequirementsDynamic(
        formData.finalJobDetails
      );
      setDynamicJobRequirement(tempObj);
    }

    return () => { };
  }, [formData.finalJobDetails]);

  useEffect(() => {
    getQuizes();
  }, []);

  const requirements2 = [
    {
      parameter: "Title",
      requirement: formData.jobDetailsRespArray?.job_title,
    },
    {
      parameter: "Experience",
      requirement: formData.jobDetailsRespArray?.job_experience,
    },
    {
      parameter: "Qualification",
      requirement: formData.jobDetailsRespArray?.job_qualifications,
    },
    {
      parameter: "Location",
      requirement: formData.jobDetailsRespArray?.location,
    },
    { parameter: "Salary", requirement: formData.jobDetailsRespArray?.salary },
    {
      parameter: "Language",
      requirement: formData.jobDetailsRespArray?.language,
    },
    {
      parameter: "Job Type",
      requirement: formData.jobDetailsRespArray?.job_type,
    },
    {
      parameter: "Work Place Type",
      requirement: formData.jobDetailsRespArray?.workplace_type,
    },
  ];
  const requirements = [
    { parameter: "No of Positions", requirement: formData.noOfPositions },
    { parameter: "Industry", requirement: formData.industry },
    { parameter: "Department", requirement: formData.department },
    { parameter: "Role", requirement: formData.jobTitle },
    { parameter: "Location", requirement: formData.location },
    { parameter: "Compensation", requirement: formData.salary },
    { parameter: "Experience", requirement: formData.experience },
    {
      parameter: "Education Level",
      requirement: formData.minEducationQualification,
    },
    {
      parameter: "Education Areas",
      requirement:
        "Business Administration/ Marketing/ Digital Marketing or related field",
    },
    { parameter: "Emp. Type", requirement: formData.employmentType },
    { parameter: "Job Type", requirement: formData.jobType },
    { parameter: "Travel", requirement: formData.travelRequirement },
    {
      parameter: "Languages",
      requirement: `English ${formData.anyLanguageOtherThanEnglish}`,
    },
    { parameter: "Required By", requirement: "January 2026" },
  ];

  const skillGroups = [
    [
      { name: "Skill", selected: true },
      { name: "Skill", selected: true },
      { name: "Skill", selected: true },
      { name: "Skill", selected: true },
      { name: "Skill", selected: true },
      { name: "Skill", selected: true },
      { name: "Skill", selected: true },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      // add more as needed
    ],
    [
      { name: "Skill", selected: true },
      { name: "Skill", selected: true },
      { name: "Skill", selected: true },
      { name: "Skill", selected: true },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },

      // add more
    ],
    [
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },
      { name: "Skill", selected: false },

      // add more
    ],
  ];
  const behavioursData = [
    {
      title: "Efficiency",
      text: `Managing simultaneous campaigns (Google Ads, Meta, LinkedIn) demands rapid execution and budget adherence. Delays risk missed KPIs or overspending.
  
  "Optimal ROI" and "continuous optimization" (CO) require team workflows to handle A/B testing, performance tracking, and real-time adjustments.`,
    },
    {
      title: "Efficiency",
      text: `Managing simultaneous campaigns (Google Ads, Meta, LinkedIn) demands rapid execution and budget adherence. Delays risk missed KPIs or overspending.
  
  "Optimal ROI" and "continuous optimization" (CO) require team workflows to handle A/B testing, performance tracking, and real-time adjustments.`,
    },
    {
      title: "Efficiency",
      text: `Managing simultaneous campaigns (Google Ads, Meta, LinkedIn) demands rapid execution and budget adherence. Delays risk missed KPIs or overspending.
  
  "Optimal ROI" and "continuous optimization" (CO) require team workflows to handle A/B testing, performance tracking, and real-time adjustments.`,
    },
    {
      title: "Efficiency",
      text: `Managing simultaneous campaigns (Google Ads, Meta, LinkedIn) demands rapid execution and budget adherence. Delays risk missed KPIs or overspending.
  
  "Optimal ROI" and "continuous optimization" (CO) require team workflows to handle A/B testing, performance tracking, and real-time adjustments.`,
    },
  ];
  const rounds = [
    {
      title: "Social Media Marketing",
      details: [
        "Quiz",
        "15 Questions",
        "Medium Difficulty",
        "Time Limit : 20 minutes",
      ],
      selected: true,
    },
    {
      title: "Social Media Marketing",
      details: [
        "Quiz",
        "15 Questions",
        "Medium Difficulty",
        "Time Limit : 20 minutes",
      ],
      selected: false,
    },
    {
      title: "Social Media Marketing",
      details: [
        "Quiz",
        "15 Questions",
        "Medium Difficulty",
        "Time Limit : 20 minutes",
      ],
      selected: false,
    },
  ];

  const handleChange = (key, val) => {
    console.log(key, val);
    setDetails((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const handleRegenerateJobDescription = async () => {

    if (!formData?.feedbackForJobDescription?.trim()) {
      toastMsg('error', 'Please Enter Prompt To Regenerate !')
      return
    }

    await generateJobDescriptionAPI(true);
    dispatch(
      updateFormField({
        field: "feedbackForJobDescription",
        value: "",
      })
    )
    setISAiGenerated(false);
    setShowSuggestionOriginal(true);
    setCustomInvt(false);
  };
  const [keywordsDifference, setKeywordsDifference] = useState([]);
  async function getDifferenceArray(arrayA, arrayB) {
    console.log("arrayA", arrayA);
    console.log("arrayB", arrayB);
    if (!Array.isArray(arrayA) || !Array.isArray(arrayB)) {
      throw new TypeError("Both inputs must be arrays.");
      return;
    }
    const setA = new Set(arrayA);
    const difference = arrayB?.filter((item) => !setA?.has(item));
    return difference;
  }

  //   useEffect( async ()=>{
  //     if(formData?.regeneratedKeywordsForUser?.length > 0 ){
  //       const temp = await getDifferenceArray(formData.generatedKeywordsForUser, formData.regeneratedKeywordsForUser);
  //       setKeywordsDifference(temp || [])
  //     }
  //
  //   },[formData?.regeneratedKeywordsForUser])
  useEffect(() => {
    const fetchDifference = async () => {
      if (formData?.regeneratedKeywordsForUser?.length > 0) {
        try {
          const temp = await getDifferenceArray(
            formData.generatedKeywordsForUser || [],
            formData.regeneratedKeywordsForUser || []
          );
          setKeywordsDifference(temp || []);
        } catch (error) {
          console.error("Error in getDifferenceArray:", error);
        }
      }
    };

    fetchDifference();
  }, [formData?.regeneratedKeywordsForUser]);
  const handleRegenerateKeywords = async () => {

    if (!formData?.feedbackForKeyWordsRegeneration?.trim()) {
      toastMsg('error', 'Please Enter Prompt For Regenerate !')
      return
    }

    await regenerateKeywordsForUserAPI();

    setShowKeywordRegenerateBox(false);
    dispatch(
      updateFormField({
        field: "feedbackForKeyWordsRegeneration",
        value: "",
      })
    )
    setShowSuggestionOriginalForKeyword(true);
    setColorOrgSuggForKeywords(false);
  };
  const handleRegenerateJobDetails = async () => {


    if (!formData?.feedbackForJonDetailsRegeneration?.trim()) {
      toastMsg('error', 'Please Enter Prompt For Regenerate ! ')
      return
    }

    await regenerateJobDetailsAPI();
    setShowJobDetailsRegenerateBox(false);
    dispatch(
      updateFormField({
        field: "feedbackForJonDetailsRegeneration",
        value: "",
      })
    )
    setShowSuggestionOriginalForJobDetails(true);
    setColorOrgSuggForJobDetails(false);
  };
  const handleRegenerateJobResponsibilities = async () => {

    if (!formData?.feedbackForJobResponsibilities?.trim()) {
      toastMsg('error', 'Please Enter Prompt For Regenerate !')
      return
    }

    await generateJobResponsibilitiesAPI(true);
    // dispatch(
    //   updateFormField({
    //     field: "feedbackForJobResponsibilities",
    //     value: "",
    //   })
    // )
    setShowSuggestionOriginalForResp(true);
    setShowRegenerateRespBox(false);
    setAiGenertdDes(false);
  };
  const handleOriginalSuggestionClick = (boolean, string) => {

    if (string === "true") {
      setISAiGenerated(true);

      dispatch(
        updateFormField({
          field: "finalSelectedJobDescription",
          value: formData.generatedJobDescription,
        })
      );
    }
    if (string === "false") {
      setISAiGenerated(false);
      dispatch(
        updateFormField({
          field: "finalSelectedJobDescription",
          value: formData.RegeneratedJobDescription,
        })
      );
    }
    if (boolean) {
      dispatch(
        updateFormField({
          field: "finalSelectedJobDescription",
          value: formData.generatedJobDescription,
        })
      );
      setShowSuggestionOriginal(false);
      return;
    }
    if (displayAiGenerated) {
      console.log("generated data");
      dispatch(
        updateFormField({
          field: "finalSelectedJobDescription",
          value: formData.generatedJobDescription,
        })
      );
      // setShowSuggestionOriginal(false);
    } else {
      console.log("regenerated data");
      dispatch(
        updateFormField({
          field: "finalSelectedJobDescription",
          value: formData.RegeneratedJobDescription,
        })
      );
      // setShowSuggestionOriginal(false);
    }
  };

  const showOrgSuggForJobDescription = (string) => {
    if (string === "original") {
      dispatch(
        updateFormField({
          field: "finalSelectedJobDescription",
          value: formData.generatedJobDescription,
        })
      );
      setISAiGenerated(true);
    } else if (string === "suggestion") {
      console.log("lllllllllllll", formData);

      dispatch(
        updateFormField({
          field: "finalSelectedJobDescription",
          value: formData.RegeneratedJobDescription,
        })
      );
      setISAiGenerated(false);
    } else if (string === "final") {
      dispatch(
        updateFormField({
          field: "generatedJobDescription",
          value: formData.finalSelectedJobDescription,
        })
      );
      setShowSuggestionOriginal(false);
    } else if (string === "close") {
      dispatch(
        updateFormField({
          field: "finalSelectedJobDescription",
          value: formData.generatedJobDescription,
        })
      );
      setShowSuggestionOriginal(false);
    }
  };

  const handleOriginalSuggestionClickForKeyWords = () => {
    setShowKeywordRegenerateBox(!showKeywordRegenerateBox);
  };
  const showOrgSuggForKeywords = (string) => {
    if (string === "original") {
      dispatch(
        updateFormField({
          field: "finalKeywordsForUser",
          value: formData.generatedKeywordsForUser,
        })
      );
      setColorOrgSuggForKeywords(true);
    } else if (string === "suggestion") {
      dispatch(
        updateFormField({
          field: "finalKeywordsForUser",
          value: formData.regeneratedKeywordsForUser,
        })
      );
      setColorOrgSuggForKeywords(false);
    } else if (string === "final") {
      dispatch(
        updateFormField({
          field: "generatedKeywordsForUser",
          value: formData.finalKeywordsForUser,
        })
      );
      dispatch(
        updateFormField({
          field: "regeneratedKeywordsForUser",
          value: [],
        })
      );
      setKeywordsDifference([]);
      setShowSuggestionOriginalForKeyword(false);
    } else if (string === "close") {
      dispatch(
        updateFormField({
          field: "finalKeywordsForUser",
          value: formData.generatedKeywordsForUser,
        })
      );
      dispatch(
        updateFormField({
          field: "regeneratedKeywordsForUser",
          value: [],
        })
      );
      setShowSuggestionOriginalForKeyword(false);
    }
  };
  const showOrgSuggForJobDetails = (string) => {
    if (string === "original") {
      dispatch(
        updateFormField({
          field: "finalJobDetails",
          value: formData.jobDetailsRespArray,
        })
      );
      setColorOrgSuggForJobDetails(true);
    } else if (string === "suggestion") {
      dispatch(
        updateFormField({
          field: "finalJobDetails",
          value: formData.regeneratedJobDetailsArray,
        })
      );
      setColorOrgSuggForJobDetails(false);
    } else if (string === "final") {
      dispatch(
        updateFormField({
          field: "jobDetailsRespArray",
          value: formData.finalJobDetails,
        })
      );
      setShowSuggestionOriginalForJobDetails(false);
    } else if (string === "close") {
      dispatch(
        updateFormField({
          field: "finalJobDetails",
          value: formData.jobDetailsRespArray,
        })
      );
      setShowSuggestionOriginalForJobDetails(false);
    }
  };
  const orgSuggForResp = (string) => {
    if (string === "original") {
      console.log(formData.generatedResponsibilities, 'Hello');
      dispatch(
        updateFormField({
          field: "finalSelectedResponsibilities",
          value: formData?.orgResponsibilties?.length > 0 ? formData?.orgResponsibilties : formData.generatedResponsibilities,
        })
      );
      setAiGenertdDes(true);
    } else if (string === "suggestion") {
      dispatch(
        updateFormField({
          field: "finalSelectedResponsibilities",
          value: formData.regeneratedResponsibilities,
        })
      );
      setAiGenertdDes(false);
    } else if (string === "final") {
      dispatch(
        updateFormField({
          field: "generatedResponsibilities",
          value: formData.finalSelectedResponsibilities,
        })
      );
      setShowSuggestionOriginalForResp(false);
    } else if (string === "close") {
      dispatch(
        updateFormField({
          field: "finalSelectedResponsibilities",
          value: formData?.orgResponsibilties?.length > 0 ? formData?.orgResponsibilties : formData.generatedResponsibilities,
        })
      );
      setShowSuggestionOriginalForResp(false);
    }
  };

  const handlePublishJDClick = () => {
    pubLishJDAPI();
  };

  const handleRemoveKeyword = (wordToRemove) => {
    const temp = formData.finalKeywordsForUser.filter(
      (word) => word !== wordToRemove
    );
    dispatch(
      updateFormField({
        field: "finalKeywordsForUser",
        value: temp,
      })
    );
  };

  const getQuizes = () => {
    simpleGetCall(ApiConfig.GET_TEMP_JOB_CODE + formData?.tempJobCode).then(
      (res) => {
        if (res?.succeded) {
          setQuizes(res?.response);
        }
      }
    );
  };


  function truncateText(text, limit) {
    if (typeof text !== 'string') return '';
    if (text.length <= limit) return text;
    return text.slice(0, limit) + '...';
  }
  const [expandedStatusIndexes, setExpandedStatusIndexes] = useState([]);
  const toggleExpandStatus = (index) => {
    setExpandedStatusIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const renderCard = (item, index, section) => {
    console.log('renderItem-->', item)
    // const isSelected =
    //   section === "recommended"
    //     ? selectedRecommendedIndexes.includes(index)
    //     : selectedOtherIndexes.includes(index);
    const isStatusExpanded = expandedStatusIndexes.includes(
      `${section}-${index}`
    );
    // const isIgnoreExpanded = expandedIgnoreIndexes.includes(
    //   `${section}-${index}`
    // );

    const fullText = item.reasonForSelection || item.reasonForNonSelection || item?.behaviourText1
    // "Primary Justification for why the behaviour has been included or excluded based on the primary recommendation. This should be of the just length and if longer should have a simple more link.";

    const shortText = truncateText(item.reasonForSelection || item?.behaviourText1, 100)
    // "Primary Justification for why the behaviour has been included or excluded based on the primary recommendation. This should be of the just length... ";

    const fullTextAvoid = item.ignoreStatus
    const shortTextAvoid = truncateText(item.ignoreStatus, 100)
    return (
      <div className="" key={index}>

        <div
          className="card-box card-box-v2"
        // style={{
        //   backgroundColor: isSelected ? item.bgColor : "white",
        //   border: `2px solid ${item.borderColor}`,
        //   cursor: "pointer",
        // }}
        >
          <div className="card-header d-flex justify-content-between">
            <h3
              className="mt-1"
              style={{
                fontWeight: 600,
                fontSize: "12px",
                color: "#101828",

              }}
            >
              {item?.title || item?.behaviourName} <span className="be-4">{item?.percentage || ''} </span>
            </h3>
            {/* <span className="select-label">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => toggleSelect(index, section)}
                  disabled={!isSelected && totalSelectedCount >= MAX_SELECTION}
                />
                <span className="slider round"></span>
              </label>
            </span> */}
          </div>

          <div className="section be-5 be-5--v2 my-behavior-min-height">
            <p
              className="section-title why-select-heading pt-2"

            >
              {/* <img src={like} width={16} height={8} /> */}
              Why Was This Recommented ?
            </p>
            <p
              style={{
                marginTop: '8px',
                color: "#68758B",
                fontSize: "11px",
                fontWeight: 500,
                letterSpacing: "0.5px",
                lineHeight: "16px",
              }}
            >
              {true ? fullText : shortText}
              {/* <span
                className="more"
                style={{ color: "blue", cursor: "pointer" }}
                onClick={() => toggleExpandStatus(`${section}-${index}`)}
              >
                {true ? "less" : "more"}
              </span> */}
            </p>
          </div>


        </div>
      </div>
    );
  };

  const [quizId, setQuizId] = useState('')
  const [jobinfoId, setJobinfoId] = useState('')
  const handleQuizEdit = (id, name, duration) => {
    console.log('quizess--', quizes,)
    setFormDataQuiz({
      quizName: name,
      quizDuration: duration
    })
    setQuizId(id)
    handleShow()
  }
  const handlePreDeleteQuiz = (quizId, jobinfoid) => {
    setJobinfoId(jobinfoid);
    setQuizId(quizId)
    handleShowDeleteQuizModal()
  }


  const handleDownloadQuiz = (id, name) => {


    simpleGetCall(ApiConfig.DOWNLOAD_QUIZ + id).then((res) => {

      if (res?.succeded) {

        FileSaver.saveAs(
          "data:" + "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" + ";base64," + res?.response,
          name + ".xlsx"
        );
      }

    })

  }


  const [loadingDeleteQuiz, setLoadingDeleteQuiz] = useState(false)
  const handleDeleteQuiz = () => {
    setLoadingDeleteQuiz(true);
    const url = `${ApiConfig.DELETE_QUIZ}?quizid=${quizId}&jobinfoid=${formData.jobDescriptionId || ''}`;
    simpleDeleteCall(url)
      .then((res) => {
        if (res?.succeded) {

          toastMsg("success", res?.response?.statusMessage);
          getQuizes();
        } else {
          toastMsg("error", res?.response?.statusMessage);
        }
      })
      .finally(() => {
        setLoadingDeleteQuiz(false);
        handleCloseDeleteQuizModal();
      });
  }
  const excludedParamsInDynamicJobRequirement = ["No Of Positions", "Department", "Description About Job", "Employment Type", "Industry", "Education Areas"];
  return (
    <>
      {loadingForGenerateJobDescription &&
        <div className="w-100 text-center">
          <p className='job_size'> Job Description is generating. Please wait <Spinner animation="grow" size='sm' /> </p>
        </div>}
      <div className="candListBox p-2 " style={{ margin: '0px' }}>

        {/* Header */}
        <div className='p-2'>

          <div
            className="bg-white shadow-md rounded-t-lg flex justify-between items-start"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div>
              {/* <h6 className="text-2xl font-bold">{formData.finalJobDetails.job_title}</h6> */}
              <h5 className="job-title jobTitleMain">{formData?.finalJobDetails?.job_title || formData?.finalJobDetails?.jobTitle}</h5>
              <p className="text-sm text-gray-600" style={{ fontSize: "12px" }}>
                {formData.finalJobDetails.location}
              </p>
            </div>
            {/* <div className="can">
            <img src={down} height={25} width={25} className='no-print' />
            <div>
              <CustomButton
                title={"Publish"}
                isDisabled={
                  loadingForPublishJD || loadingForGenerateJobDescription
                }
                isLoading={loadingForPublishJD}
                handleClick={handlePublishJDClick}
                icon={send}
              />
            </div>
          </div> */}
          </div>

          {/* Invitation to Apply Section */}
          <div className="bg-white border-t-2 border-blue-500 shadow-md">
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: '-10px', }}>
              {" "}
              <h5 className="job-title mt-3 mainTitleColr">Invitation to Apply</h5>
              {
                !formData?.isView &&

                <div className="no-print " style={{ marginBottom: '0.5rem' }} >

                  <CustomButton
                    title="Edit/Refine With AI"
                    isLoading={false}
                    buttonType="secondary"
                    handleClick={() => setCustomInvt(true)}
                  />
                </div>
              }

            </div>
            {showSuggestionOriginal ? (
              <div className="d-flex justify-content-end mb-2">
                <button
                  className={`buttonCusSug ${displayAiGenerated && "colorActve"}`}
                  // onClick={() => setISAiGenerated(true)}
                  onClick={() => showOrgSuggForJobDescription("original")}
                >
                  Original
                </button>
                <button
                  className={`buttonCusSug ${!displayAiGenerated && "colorActve"
                    }`}
                  // onClick={() => setISAiGenerated(false)}
                  onClick={() => showOrgSuggForJobDescription("suggestion")}
                >
                  Suggestion
                </button>
                <button
                  className="buttonCusSug"
                  onClick={() => showOrgSuggForJobDescription("final")}
                >
                  {" "}
                  <img src={check} style={{ width: "20px" }} />
                </button>
                <button
                  className="buttonCusSug"
                  onClick={() => showOrgSuggForJobDescription("close")}
                >
                  {" "}
                  <img src={close} style={{ width: "18px" }} />
                </button>
              </div>
            ) : null}
            {isAddCustInvt && (
              <div>
                {" "}
                <textarea
                  minLength={3}
                  value={formData?.feedbackForJobDescription}
                  onChange={(e) =>
                    dispatch(
                      updateFormField({
                        field: "feedbackForJobDescription",
                        value: e.target.value,
                      })
                    )
                  }
                  style={{ height: "60px" }}
                  className="w-full p-2 rounded-md  border border-grey text-black placeholder-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 jb-in-1 mt-2"
                />
                <div className="d-flex justify-content-end  mt-2 mb-2 gap-2">
                  <CustomButton
                    isLoading={false}
                    handleClick={() => setCustomInvt(false)}
                    title="Cancel"
                    buttonType="secondary"
                  />
                  <CustomButton
                    isLoading={loadingForRegenerateJobDescription}
                    handleClick={handleRegenerateJobDescription}
                    title="Generate"
                  />
                </div>
              </div>
            )}

            <p
              className="candListBox candListBoxMra"
              style={{ margin: "0px", fontSize: "12px", height: "85%" }}
            >
              {displayAiGenerated ? (
                loadingForGenerateJobDescription ? (
                  <ShimmerText line={5} gap={10} />
                ) : (
                  formData.finalSelectedJobDescription ||
                  formData.generatedJobDescription
                )
              ) : (
                <>
                  {/* formData.RegeneratedJobDescription */}
                  {formData.finalSelectedJobDescription}
                </>
              )}
            </p>
          </div>

          {/* Keywords Section */}
          <div className="bg-white shadow-md rounded-b-lg mt-3">
            <div style={{ display: "flex", justifyContent: "space-between " }}>
              <h5 className="job-title mt-3">Job Descriptors</h5>
              {/* <h3
            className="text-blue-600 font-semibold mb-2"
            style={{ fontSize: "1rem", fontWeight: 600 }}
          >
            Key Words Describing the Job
          </h3> */}
              {/* <p
              className="mar-but1 no-print"
              style={{
                fontSize: "13px",
                display: "flex",
                gap: "6px",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => setShowKeywordRegenerateBox(true)}
            >
              <img src={star} height={10} width={10} /> Edit/refine with AI
            </p> */}
              {
                !formData?.isView &&
                <div style={{ marginBottom: '0.5rem' }}>
                  <CustomButton
                    isLoading={false}
                    title="Edit/Refine With AI"
                    handleClick={() => setShowKeywordRegenerateBox(true)}
                    buttonType={'secondary'}
                  />
                </div>
              }
            </div>
            {showSuggestionOriginalForKeyword ? (
              <div className="d-flex justify-content-end mb-2">
                <button
                  className={`buttonCusSug ${colorOrgSuggForKeywords && "colorActve"
                    }`}
                  onClick={() => showOrgSuggForKeywords("original")}
                >
                  Original
                </button>
                <button
                  className={`buttonCusSug ${!colorOrgSuggForKeywords && "colorActve"
                    }`}
                  onClick={() => showOrgSuggForKeywords("suggestion")}
                >
                  Suggestion
                </button>
                <button
                  className="buttonCusSug"
                  onClick={() => showOrgSuggForKeywords("final")}
                >
                  {" "}
                  <img src={check} style={{ width: "20px" }} />
                </button>
                <button
                  className="buttonCusSug"
                  onClick={() => showOrgSuggForKeywords("close")}
                >
                  {" "}
                  <img src={close} style={{ width: "18px" }} />
                </button>
              </div>
            ) : null}
            {showKeywordRegenerateBox && (
              <div>
                {" "}
                <textarea
                  minLength={7}
                  value={formData?.feedbackForKeyWordsRegeneration}
                  onChange={(e) =>
                    dispatch(
                      updateFormField({
                        field: "feedbackForKeyWordsRegeneration",
                        value: e.target.value,
                      })
                    )
                  }
                  style={{ height: "60px" }}
                  className="w-full p-2 rounded-md  border border-grey text-black placeholder-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 jb-in-1 mt-2"
                />
                <div className="d-flex justify-content-end  mt-2 mb-2 gap-2">
                  <CustomButton
                    isLoading={false}
                    handleClick={() => setShowKeywordRegenerateBox(false)}
                    title="Cancel"
                    buttonType="secondary"
                  />
                  <CustomButton
                    isLoading={loadingForRegeneratedKeywords}
                    handleClick={handleRegenerateKeywords}
                    title="Generate"
                  />
                </div>
              </div>
            )}
            {console.log("keywordsDifference-->", keywordsDifference)}
            <div className="keywordsBox d-flex flex-wrap gap-2 ">
              {loadingForGeneratedCustomQuestions ? (
                <div>
                  {" "}
                  <ShimmerText
                    line={5}
                    gap={10}
                    className="width-of-shimmer"
                    style={{ width: "1200" }}
                  />{" "}
                </div>
              ) : (
                formData.finalKeywordsForUser?.length > 0 &&
                formData.finalKeywordsForUser?.map((word, index) => (
                  <div className='d-flex justify-content-center align-items-center ' key={index}>
                    <span
                      key={index}
                      className={`bg-gray-200 text-sm text-blue-800 px-3 py-1 rounded-full flex items-center ${keywordsDifference?.includes(word)
                        ? "mar-key--v2"
                        : "mar-key"
                        } `}
                    // style={{ fontSize: '14px' }}
                    >
                      {word}
                      {
                        !formData?.isView &&

                        <button
                          style={{ marginLeft: '15px' }}
                          onClick={() => handleRemoveKeyword(word)}
                          className={`ml-4 text-red-500 font-bold ${keywordsDifference?.includes(word)
                            ? "mar-key-butt--v2"
                            : "mar-key-butt"
                            } `}
                        >
                          ×
                        </button>
                      }
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>
          <div className="col-12 col-md-12  page-break mt-3" >
            <div className="row">
              <div className="col-5 col-md-4">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <h5 className="job-title mt-3 mainTitleColr">Job Requirements</h5>
                  {/* <h3
                className="text-blue-600 font-semibold mb-2"
                style={{ fontSize: "1rem", fontWeight: 600 }}
              >
                Job Requirements
              </h3> */}
                  {/* <p
                  className="mar-but1 no-print"
                  style={{
                    fontSize: "13px",
                    display: "flex",
                    gap: "6px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowJobDetailsRegenerateBox(true)}
                >
                  <img src={star} height={10} width={10} /> Edit/refine with AI
                </p> */}
                  {
                    !formData?.isView &&
                    <div style={{ marginBottom: '0.5rem' }}>
                      <CustomButton
                        isLoading={false}
                        title="Edit/Refine With AI"
                        handleClick={() => setShowJobDetailsRegenerateBox(true)}
                        buttonType={'secondary'}
                      />
                    </div>
                  }
                </div>
                {showSuggestionOriginalForJobDetails ? (
                  <div className="d-flex justify-content-end mb-2">
                    <button
                      className={`buttonCusSug ${colorOrgSuggForJobDetails && "colorActve"
                        }`}
                      onClick={() => showOrgSuggForJobDetails("original")}
                    >
                      Original
                    </button>
                    <button
                      className={`buttonCusSug ${!colorOrgSuggForJobDetails && "colorActve"
                        }`}
                      onClick={() => showOrgSuggForJobDetails("suggestion")}
                    >
                      Suggestion
                    </button>
                    <button
                      className="buttonCusSug"
                      onClick={() => showOrgSuggForJobDetails("final")}
                    >
                      {" "}
                      <img src={check} style={{ width: "20px" }} />
                    </button>
                    <button
                      className="buttonCusSug"
                      onClick={() => showOrgSuggForJobDetails("close")}
                    >
                      {" "}
                      <img src={close} style={{ width: "18px" }} />
                    </button>
                  </div>
                ) : null}
                {showJobDetailsRegenerateBox && (
                  <div>
                    {" "}
                    <textarea
                      minLength={7}
                      value={formData?.feedbackForJonDetailsRegeneration}
                      onChange={(e) =>
                        dispatch(
                          updateFormField({
                            field: "feedbackForJonDetailsRegeneration",
                            value: e.target.value,
                          })
                        )
                      }
                      style={{ height: "60px" }}
                      className="w-full p-2 rounded-md  border border-grey text-black placeholder-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 jb-in-1 mt-2"
                    />
                    <div className="d-flex justify-content-end  mt-2 mb-2 gap-2">
                      <CustomButton
                        isLoading={false}
                        handleClick={() => setShowJobDetailsRegenerateBox(false)}
                        title="Cancel"
                        buttonType="secondary"
                      />
                      <CustomButton
                        isLoading={loadingForRegeneratedJobDetails}
                        handleClick={handleRegenerateJobDetails}
                        title="Generate"
                      />
                    </div>
                  </div>
                )}
                <div
                  className="candListBox"
                  style={{ margin: "0px", height: "94%" }}
                >
                  {loadingForGenerateJobDescription ? (
                    <ShimmerTable row={4} col={2} />
                  ) : (
                    <table className="job-req-table thirdTitle" >
                      <thead>
                        <tr>
                          <th>Parameter</th>
                          <th>Requirement</th>
                        </tr>
                      </thead>
                      <tbody>
                        {console.log('dynamicJobRequirement--', dynamicJobRequirement)}
                        {dynamicJobRequirement?.length > 0 &&
                          dynamicJobRequirement?.filter(item => !excludedParamsInDynamicJobRequirement.includes(item.parameter))?.map((item, index) => (
                            <tr key={index} style={{ fontSize: "12px" }}>
                              <td>{item.parameter}</td>
                              <td>{item.requirement}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
              <div className="col-7 col-md-8">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between"
                  }}
                >
                  <h5 className="job-title mt-3 mainTitleColr">Responsibilities</h5>
                  {/* <h3
                className="text-blue-600 font-semibold mb-2"
                style={{ fontSize: "1rem", fontWeight: 600 }}
              
                Responsibilities
              </h3> */}
                  {/* <p
                  className="mar-but1 no-print"
                  style={{
                    fontSize: "13px",
                    display: "flex",
                    gap: "6px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowRegenerateRespBox(true)}
                >
                  <img src={star} height={10} width={10} /> Edit/refine with AI
                </p> */}
                  {
                    !formData?.isView &&
                    <div style={{ marginBottom: '0.5rem' }}>
                      <CustomButton
                        isLoading={false}
                        title="Edit/Refine With AI"
                        handleClick={() => setShowRegenerateRespBox(true)}
                        buttonType={'secondary'}
                      />
                    </div>
                  }
                </div>
                {showSuggestionOriginalForResp ? (
                  <div className="d-flex justify-content-end mb-2">
                    <button
                      className={`buttonCusSug ${displayAiGenrtdDes && "colorActve"
                        }`}
                      onClick={() => orgSuggForResp("original")}
                    >
                      Original
                    </button>
                    <button
                      className={`buttonCusSug ${!displayAiGenrtdDes && "colorActve"
                        }`}
                      onClick={() => orgSuggForResp("suggestion")}
                    >
                      Suggestion
                    </button>
                    <button
                      className="buttonCusSug"
                      onClick={() => orgSuggForResp("final")}
                    >
                      {" "}
                      <img src={check} style={{ width: "20px" }} />
                    </button>
                    <button
                      className="buttonCusSug"
                      onClick={() => orgSuggForResp("close")}
                    >
                      {" "}
                      <img src={close} style={{ width: "20px" }} />
                    </button>
                  </div>
                ) : null}
                {showRegenerateRespBox && (
                  <div>
                    {" "}
                    <textarea
                      minLength={7}
                      value={formData?.feedbackForJobResponsibilities}
                      onChange={(e) =>
                        dispatch(
                          updateFormField({
                            field: "feedbackForJobResponsibilities",
                            value: e.target.value,
                          })
                        )
                      }
                      style={{ height: "60px" }}
                      className="w-full p-2 rounded-md  border border-grey text-black placeholder-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 jb-in-1 mt-2"
                    />
                    <div className="d-flex justify-content-end gap-2 mt-2 mb-2 gap-2">
                      <CustomButton
                        isLoading={false}
                        handleClick={() => setShowRegenerateRespBox(false)}
                        title="Cancel"
                        buttonType="secondary"
                      />
                      <CustomButton
                        isLoading={loadingForRegenerateJobResponsibilities}
                        handleClick={handleRegenerateJobResponsibilities}
                        title="Generate"
                      />
                    </div>
                  </div>
                )}
                <div
                  className="candListBox"
                  style={{ margin: "0px", height: "94%" }}
                >
                  <div className="responsibilities-section">
                    <>
                      {loadingForGenerateJobDescription ? (
                        <ShimmerText line={15} gap={10} />
                      ) : (
                        formData?.finalSelectedResponsibilities?.length > 0 &&
                        formData?.finalSelectedResponsibilities?.map(
                          (group, index) => (
                            <div key={index} className="mb-4">
                              <h4 className=" " style={{ fontSize: "14px" }}>
                                {group?.responsibilites_group || group?.groupTitle}
                              </h4>
                              <ul>
                                {
                                  formData?.isView ?
                                    group?.responsibilities?.map((item, idx) => (
                                      <li key={idx}>{item?.responsibilityText ? item?.responsibilityText : item}</li>
                                    ))
                                    : group?.responsibilities ?
                                      group?.responsibilities?.map((item, idx) => (
                                        <li key={idx}>{item?.responsibilityText ? item?.responsibilityText : item}</li>
                                      )) :
                                      group?.responsibilites?.map((item, idx) => (
                                        <li key={idx}>{item?.responsibilityText ? item?.responsibilityText : item}</li>
                                      ))
                                }

                              </ul>
                            </div>
                          )
                        )
                      )}

                      {/* <h4>Digital Strategy and Campaign Execution</h4>
                    <ul>
                      <li>
                        Plan, develop, and execute comprehensive digital
                        marketing strategies to elevate brand awareness and
                        generate qualified leads aligned with Solon India’s
                        business objectives.
                      </li>
                      <li>
                        Manage and optimize digital campaigns across Google Ads,
                        Meta (Facebook/Instagram), and LinkedIn Ads, ensuring
                        optimal ROI and alignment with budget allocations.
                      </li>
                      <li>
                        Design, test, and optimize landing pages, forms, and
                        user journeys to improve conversion rates and user
                        engagement.
                      </li>
                      <li>
                        Collaborate with cross-functional teams, including sales
                        and product development, to ensure cohesive messaging
                        and campaign alignment.
                      </li>
                      <li>
                        Conduct market research and competitive analysis to
                        identify opportunities for growth and innovation in
                        digital marketing initiatives.
                      </li>
                      <li>
                        Ensure all digital marketing activities comply with
                        industry regulations and company policies, including
                        data privacy and advertising standards.
                      </li>
                    </ul> */}

                      {/* <h4>SEO/SEM and Website Optimization</h4>
                    <ul>
                      <li>
                        Perform in-depth keyword research and implement on-page
                        and off-page SEO best practices to enhance search engine
                        rankings and organic traffic.
                      </li>
                      <li>
                        Monitor website performance using Google Analytics,
                        Search Console, and other analytics tools, identifying
                        areas for improvement and implementing necessary
                        changes.
                      </li>
                      <li>
                        Conduct A/B testing and conversion rate optimization
                        (CRO) strategies to maximize website effectiveness and
                        improve user experience.
                      </li>
                      <li>
                        Collaborate with the web development team to ensure
                        website structure, content, and functionality are
                        optimized for search engines and user engagement.
                      </li>
                      <li>
                        Stay up-to-date with the latest SEO trends and algorithm
                        updates, adapting strategies to maintain and improve
                        search engine visibility.
                      </li>
                      <li>
                        Generate regular reports on website performance,
                        providing actionable insights and recommendations to
                        leadership.
                      </li>
                    </ul>

                    <h4>Content Creation and Social Media Management</h4>
                    <ul>
                      <li>
                        Create, curate, and manage engaging content for blogs,
                        social media platforms, email marketing campaigns, and
                        other digital channels.
                      </li>
                      <li>
                        Develop and maintain a content calendar aligned with
                        product launches, campaign goals, and industry events,
                        ensuring consistent and relevant content delivery.
                      </li>
                      <li>
                        Interact with followers, respond to queries, and manage
                        brand voice across all social media platforms, fostering
                        a positive and engaging online community.
                      </li>
                      <li>
                        Collaborate with subject matter experts to create
                        informative and thought-provoking content that showcases
                        Solon India’s expertise in the renewable energy sector.
                      </li>
                    </ul> */}
                    </>
                  </div>
                </div>
              </div>
              {/* <div className=" bg-white mt-4 page-break">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  {" "}
                  <div>
                    <h5 className="job-title mt-1 mainTitleColr">Skill Required for the Job</h5>
                    <p className='my-behavior-header-text font-weight-500-- p-0 mainTitleColr' style={{ marginTop: '-8px' }}>Recommended ones are already selected</p>
                  </div>
                  <div>
                    {!formData.isView && (

                      <div style={{ marginBottom: '0.5rem' }}>
                        <CustomButton
                          isLoading={false}
                          title="Edit/Refine With AI"
                          handleClick={() => setIsEditGroup(true)}
                          buttonType={'secondary'}
                        />
                      </div>
                    )}

                  </div>

                </div>

                <div className="keywordsBox" style={{ margin: '0px', marginTop: '-10px' }}>

                  {loadingForGenerateSkills ? (
                    <div className="w-100 h-100 text-center">
                      <ShimmerText line={5} gap={10} />{" "}
                    </div>
                  ) : (
                    <NewSkill loadingForRegenerateSkills={loadingForRegenerateSkills} regenerateSkillsAPI={regenerateSkillsAPI} setIsEditGroup={setIsEditGroup} isEditGroup={isEditGroup} />

                  )

                  }
                </div>
              </div> */}
            </div>
          </div>
          {/* <div className="mt-3" >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <h5 className="job-title mt-2 mainTitleColr">Behaviours</h5>
                <div>
                  <p className='my-behavior-header-text font-weight-500-- p-0' style={{ marginBottom: '3px', marginTop: '-8px' }}>Recommended ones are already selected - you can select only upto 4 behaviors</p>
                </div>
              </div>
              {
                !formData?.isView &&
                <div className="no-print mb-2" >
                  <CustomButton
                    title="Change Selection"
                    isDisabled={loadingForGettingBehaviour}
                    isLoading={false}
                    buttonType="secondary"
                    handleClick={() => navigate("/BehaviorsPage")}
                  />

                </div>
              }




            </div>

            {showRegenerateBoxForBehaviour && (
              <div>
                {" "}
                <textarea
                  minLength={7}
                  value={formData?.feedbackForJobDescription}
                  onChange={(e) =>
                    dispatch(
                      updateFormField({
                        field: "feedbackForJobDescription",
                        value: e.target.value,
                      })
                    )
                  }
                  style={{ height: "150px" }}
                  className="w-full p-2 rounded-md  border border-grey text-black placeholder-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 jb-in-1 mt-2"
                />
                <div className="d-flex justify-content-end  mt-2 mb-2">
                  <button
                    className="btnVldt  "
                    onClick={() => setShowRegenerateBoxForBehaviour(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btnVldt  "
                    style={{ marginRight: "0px" }}
                    disabled={loadingForRegenerateJobDescription}
                    onClick={handleRegenerateJobDescription}
                  >
                    {loadingForRegenerateJobDescription ? (
                      <Spinner />
                    ) : (
                      "Generate"
                    )}
                  </button>
                </div>
              </div>
            )}
            <div className="skills-box p-0 mt-2">

              {
                console.log(formData?.behaviorsDataApi, "amir ")
              }
              <div className="behaviour-container--  my-behaviour-container-2">
                {loadingForGettingBehaviour ? <ShimmerSimpleGallery card imageHeight={250} row={1} col={4} /> : (

                  formData?.behaviorsDataApi?.selectedByUser?.map((item, index) =>
                    renderCard(item, index, "recommended--")

                  )
                )}
              </div>
           

            </div>
          </div> */}
        </div>
        <div className=" p-2">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h5 className="job-title mainTitleColr">
              Screening Rounds (Quizzes or Assignments)
            </h5>

          </div>

          <p className='my-behavior-header-text font-weight-500-- p-0 mainTitleColr' style={{ marginTop: '-8px' }}>Create quizzes using AI</p>
        </div>
        <div className="skills-box " style={{ marginTop: '-15px', marginLeft: '10px' }}>
          <div className="screening-container " >
            {quizes?.map((quiz, index) => (
              <div
                className={`quiz-card `}
                // ${round.selected ? "selected" : ""}
                key={index}
                style={{ position: 'relative' }}
              >
                {" "}
                <h4 className="quiz-title">{quiz?.quizName}</h4>
                <ul className="quiz-details">
                  <li>{quiz?.noOfQuestions} Questions</li>
                  <li>Difficulty {quiz?.difficultyLevel}</li>
                  <li>Time Limit {quiz?.duration}</li>
                </ul>
                {!formData.isView && (
                  <div>

                    <img
                      onClick={() => handlePreDeleteQuiz(quiz.quizId)}
                      src={del}
                      height={20}
                      width={20}
                      alt="edit"
                      style={{
                        cursor: "pointer", position: 'absolute', top: '0%',
                        right: '0%',
                        height: '32px',
                        width: '32px'
                      }}

                    />
                    <img
                      onClick={() => handleQuizEdit(quiz.quizId, quiz.quizName, quiz.duration)}
                      src={pen}
                      height={20}
                      width={20}
                      alt="edit"
                      style={{
                        cursor: "pointer", position: 'absolute', top: '0%',
                        right: '7%',
                        height: '32px',
                        width: '32px'
                      }}

                    />
                  </div>
                )}
                <img
                  onClick={() => handleDownloadQuiz(quiz.quizId, quiz.quizName)}
                  src={download}
                  height={16}
                  width={16}
                  alt="Download"
                  style={{
                    cursor: "pointer", position: 'absolute', top: '0%',
                    marginTop: '4px',
                    right: formData.isView ? '2%' : '16%',
                    height: '20px',
                    width: '20px'
                  }}

                />

              </div>
            ))}
            {
              !formData?.isView &&
              <div
                className="quiz-add-card"
                onClick={() => {
                  // dispatch(updateFormField({ field: 'topics', value: [] }))
                  // dispatch(updateFormField({ field: 'subTopics', value: [] }))
                  navigate("/Topics");
                }}
              >
                Add Quiz
              </div>
            }
          </div>
        </div>
        {/* ////////////////////////////////////////////////////////////// */}

        <Modal centered show={show} onHide={handleClose}>
          <Modal.Header closeButton className="custom-close-btn">
            <h6 className="mb-0 mt-1">Quiz Details</h6>
          </Modal.Header>
          <Modal.Body>
            <Form noValidate onSubmit={handleSubmit}>
              <Form.Group controlId="designation" className="mb-3">
                <Row className="align-items-center">
                  <Col sm={3}>
                    <Form.Label className="job_size">Quize Name</Form.Label>
                  </Col>
                  <Col sm={9}>
                    {/* <Form.Label className="job_size">Company Name</Form.Label> */}
                    <Form.Control
                      type="text"
                      className="input-text-14"
                      required
                      placeholder="Quiz Name"
                      value={formDataQuiz?.quizName}
                      onChange={(e) => handleChangeForQuizDetails('quizName', e.target.value)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please Enter Quiz Name!
                    </Form.Control.Feedback>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group controlId="designation" className="mb-3">
                <Row className="align-items-center">
                  <Col sm={3}>
                    <Form.Label className="job_size">Quiz Duration</Form.Label>
                  </Col>
                  <Col sm={9}>

                    <Form.Select aria-label="Default select example"
                      name='quizDuration'
                      value={formDataQuiz?.quizDuration}
                      onChange={(e) => handleChangeForQuizDetails('quizDuration', e.target.value)}
                      className="selectPlaceholder"
                      placeholder="Select Quiz Duration"

                    >
                      <option value={""} disabled>Select Quiz Duration</option>
                      {
                        duration?.map((type, index) => {
                          return <option value={type?.value} key={index}
                            className="job_size"
                            style={{ fontSize: "14px", color: "red" }}
                          >{type?.label}</option>
                        })
                      }

                    </Form.Select>

                    <Form.Control.Feedback type="invalid">
                      Please Select Quiz Duration!
                    </Form.Control.Feedback>
                  </Col>
                </Row>
              </Form.Group>
            </Form>

          </Modal.Body>
          <Modal.Footer>

            <CustomButton
              title={'Close'}
              handleClick={handleClose}
              buttonType='secondary'

            />

            <CustomButton
              title={'Update'}
              handleClick={handleSubmit}

              isLoading={isSubmit}
            />
          </Modal.Footer>
        </Modal>



        <Modal centered show={showDeleteQuizModal} onHide={handleCloseDeleteQuizModal}>
          <Modal.Header closeButton className="custom-close-btn">
            <h6 className="mb-0 mt-1">Delete Quiz</h6>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure want to delete this quiz? </p>
          </Modal.Body>
          <Modal.Footer>

            <CustomButton
              title={'Close'}
              handleClick={handleCloseDeleteQuizModal}
              buttonType='secondary'

            />

            <CustomButton
              title={'Delete'}
              handleClick={handleDeleteQuiz}

              isLoading={loadingDeleteQuiz}
            />
          </Modal.Footer>
        </Modal>


        {/* //////////////////////////////////////////////////////////// */}
      </div >
    </>
  );
}
